import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {httpGeoSelect} from '@features/settings/http/settings.http.ts'
import {captureException} from '@sentry/react'
import {AreaResponse} from '@features/settings/types'

export const useGeos = ({
    countries,
    options
}: {
    countries: string[]
    options?: Omit<UseQueryOptions<unknown, unknown, AreaResponse>, 'queryFn' | 'queryKey'>
}) =>
    useQuery({
        queryKey: [QUERY_KEYS.GEO_SELECT, countries],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGeoSelect({params: {countries}}),
                responseShape: AreaResponse,
                onZodError: captureException
            }),
        ...options
    })
